jQuery(document).ready(function($) {
    if (!window.WebAssessmentCharts) {
        window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
    }		
	let projectID;
	if ($('body').hasClass('single-projects')) {
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
		}
	}
	
	console.log('Extracted projectID:', projectID); // Verify the extracted project ID
	
	// Now using utility function from fetchProjectChartData.js
	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	// Fetch project data and CRF data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function(projectID) {
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
		}
		
		try {
			// Fetch project data
			const projectData = await WebAssessmentCharts.fetchProjectChartData(projectID);
			
			// Check if project data is valid
			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}
			
			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('processedItems:', processedItems);
			
			// Fetch NIST standards data directly
			try {
                const response = await jQuery.ajax({
                    url: controlsData.ajax_url,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'api_action',
                        year: '2024',
                        apis: ['CS'],
                        CSLstandardID: 'NIST-CSF-1-0'
                    }
                });

				console.log('NIST Standards response structure:', JSON.stringify(response, null, 2));
				// Store the response for use by other functions
				WebAssessmentCharts.nistStandardData = response;

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid NIST standards response structure:', response);
					return;
				}
				
				// Now run the NISTCSF10 function with the enhanced data
				WebAssessmentCharts.NISTCSF10(processedItems, response);
			}
			catch (error) {
				console.error('Error fetching NIST standards:', error);
				// If we fail to get standards data, we can still try to show the NIST chart with the data we have
				WebAssessmentCharts.NISTCSF10(processedItems);
			}
			
			$('.modal-body .loader').hide();
			
		} catch (error) {
			console.error('Error processing data:', error);
			$('.modal-body .loader').hide();
		}
	}

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		WebAssessmentCharts.registerHomeDashboardFetcher('nist-csf-1-0', WebAssessmentCharts.fetchDataAndCalculateScores);
	}
	
	// Now using utility function from calculateMaturityScore.js
	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;
	
	// Now using utility function from getMostRecentSafeguards.js
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;
	
	// Now using utility function from processUniqueItemsCIS.js
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;
	
	var homeFrameworkCalculateNISTCategoryAverages = WebAssessmentCharts.calculateNISTCategoryAverages = function(items, nistStandardData) {
		const categoryScores = {};
		const categoryPotentialCounts = {};
		
		// First gather potential counts from NIST standard data if available
		if (nistStandardData && nistStandardData.CS && nistStandardData.CS.Items) {
			nistStandardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					const safeguardId = control.controlid.S;
					const parts = safeguardId.split('-'); // e.g., 'GV.RM-01'
					const category = parts[0]; // Extract 'GV.RM'
					
					if (!categoryPotentialCounts[category]) {
						categoryPotentialCounts[category] = 0;
					}
					categoryPotentialCounts[category]++;
				}
			});
		}
		console.log("NIST Category potential counts: ", categoryPotentialCounts);
		
		// Initialize category scores structure with potential counts
		Object.keys(categoryPotentialCounts).forEach(category => {
			categoryScores[category] = { 
				total: 0, 
				count: 0, 
				nullCount: 0, 
				totalItems: 0,
				applicableItems: 0,
				potentialCount: categoryPotentialCounts[category]
			};
		});

		// Process actual scores from items
		items.forEach(item => {
			const safeguardId = item.safeguardid.S;
			const parts = safeguardId.split('-'); // e.g., 'GV.RM-01'
			const category = parts[0]; // Extract 'GV.RM'
			const maturityScore = item.maturityscore; // Can be null
			const policystatus = parseInt(item.policystatus.N, 10);

			if (!categoryScores[category]) {
				categoryScores[category] = { 
					total: 0, 
					count: 0, 
					nullCount: 0, 
					totalItems: 0,
					applicableItems: 0,
					potentialCount: categoryPotentialCounts[category] || 0
				};
			}

			categoryScores[category].totalItems++;

			// Check if item is Not Applicable (policy status 1)
			if (policystatus === 1) {
				categoryScores[category].nullCount++;
			} else {
				// Item is applicable (whether filled out or not)
				categoryScores[category].applicableItems++;
				
				// Only add to total if it has a maturity score
				if (maturityScore !== null) {
					categoryScores[category].total += maturityScore;
					categoryScores[category].count++;
				}
			}
		});

		// Log detailed information about category scores before calculating averages
		console.log("NIST Category scores before averaging: ", JSON.stringify(categoryScores, null, 2));

		const averages = {};
		Object.keys(categoryScores).forEach(category => {
			const { total, count, nullCount, totalItems, applicableItems, potentialCount } = categoryScores[category];
			
			// If all items in category are marked as "Not Applicable" (policy status 1), set average to null
			if (nullCount === totalItems && totalItems > 0) {
				averages[category] = null;
			} else {
				// Use applicableItems as denominator (total items minus Not Applicable items)
				const denominator = applicableItems > 0 ? applicableItems : (potentialCount || count);
				averages[category] = denominator > 0 ? total / denominator : 0;
				console.log(`Category ${category}: total=${total}, applicableItems=${applicableItems}, potentialCount=${potentialCount}, actual count=${count}, nullCount=${nullCount}, denominator=${denominator}, average=${averages[category]}`);
			}
		});

		console.log("NIST Category averages: ", averages);
		return averages;
	}
	
	WebAssessmentCharts.NISTCSF10 = function(items, nistStandardData) {
		console.log('Starting NISTCSF10 function...');
		const tableBody = document.querySelector('#nist10 tbody');
		if (!tableBody) {
			console.error('NIST CSF 1.0 table body not found.');
			return;
		}

		// Store original row indices before any modifications
		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});

		// Create a map of all possible safeguards from the standard
		const allSafeguards = new Map();
		if (nistStandardData && nistStandardData.CS && nistStandardData.CS.Items) {
			nistStandardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" }, // Default to "Not Answered"
						maturityscore: 0 // Default score for unanswered items
					});
				}
			});
		}

		// Merge in any existing answers
		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			allSafeguards.set(item.safeguardid.S, item);
		});

		// Convert back to array
		const mergedItems = Array.from(allSafeguards.values());
		console.log('Merged items (including unanswered):', mergedItems);

		// Calculate averages by category
		const averageScores = homeFrameworkCalculateNISTCategoryAverages(mergedItems, nistStandardData);

		// Keep track of rows to remove
		const rowsToRemove = [];

		// Make all rows visible first
		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});

		// Update the table
		Array.from(tableBody.rows).forEach((row, index) => {
			const categoryLabel = row.cells[0].textContent.trim();
			const regex = /\((DE|ID|PR|RS|RC|GV)\.([A-Z]+)\)/;
			const match = categoryLabel.match(regex);

			if (match) {
				const category = `${match[1]}.${match[2]}`; // e.g., 'DE.AE'
				if (averageScores[category] !== undefined) {
					if (averageScores[category] === null) {
						// Only remove rows that are explicitly marked as not applicable
						// (all items in the category have policy status 1)
						rowsToRemove.push(row);
					} else {
						const averageScore = averageScores[category] * 5; // Scale average score
						row.cells[1].textContent = averageScore.toFixed(2);
						console.log(`Updated ${category} in row ${index + 1} with averageScore:`, averageScore.toFixed(2));
					}
				} else {
					row.cells[1].textContent = "0.00";
					console.warn(`No data for category ${category} at row ${index + 1}`);
				}
			} else {
				row.cells[1].textContent = "0.00";
				console.warn(`No regex match found for category label at row ${index + 1}: ${categoryLabel}`);
			}
		});

	// Remove rows with all null values (all items are Not Applicable)
	rowsToRemove.forEach(row => {
		row.remove();
	});

	// Calculate core function averages using utility function
	const coreFunctionAverages = calculateCoreFunctionAverages(averageScores);

	// Calculate overall maturity from core function averages instead of safeguard domains
	const coreFunctionValues = Object.values(coreFunctionAverages);
	var overallMaturity = 0;
	if (coreFunctionValues.length > 0) {
		overallMaturity = coreFunctionValues.reduce((sum, value) => sum + value, 0) / coreFunctionValues.length;
	}

	const maturityRatingRow = $('#nist10 .light-background td');
	if (maturityRatingRow.length > 0) {
		WebAssessmentCharts.overallNIST10maturity = overallMaturity;
		WebAssessmentCharts.nist10CoreFunctionAverages = coreFunctionAverages;  // Store core function averages
		console.log('overallMaturityScore inside web-assessment-charts-nist10.js is '+WebAssessmentCharts.overallNIST10maturity);
		console.log('Core function averages stored:', WebAssessmentCharts.nist10CoreFunctionAverages);
		maturityRatingRow.text(formatScore(overallMaturity));
		$('.audit-overall-value').text(formatScore(overallMaturity));
		$('.nist10-overall-value').text(formatScore(overallMaturity));
		console.log(`Updated audit-overall-value with core function average: ${formatScore(overallMaturity)}`);
		$('.spinner-border').hide();
		$('.mark-complete-modal-buttons').show();
	} else {
		console.error("Error: Maturity rating row not found in the table.");
	}

	// Update the core functions table with calculated averages using utility function
	updateCoreFunctionsTable('nist10-core-functions', coreFunctionAverages, formatScore);

	// Show the NIST container and create charts
	applyFrameworkPanelVisibility('show', '.nist10-container');
	WebAssessmentCharts.createChartFromTable('nist10', 'nist10-chart', charts, true);
	if (document.getElementById('nist10-core-functions-chart')) {
		WebAssessmentCharts.createChartFromTable('nist10-core-functions', 'nist10-core-functions-chart', charts, true);
	}

		// Restore original row indices after chart creation
		rowsToRemove.forEach(row => {
			const originalIndex = originalIndices.get(row);
			if (originalIndex !== undefined) {
				tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
				row.style.display = 'none';
			}
		});
	}
	
	// Object to keep track of charts
	var charts = {};
	
	$('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');
		
		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		// Instantly toggle the table's visibility
		dataTable.toggle();

		// Use a minimal timeout to allow the DOM to update after the toggle.
		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20; // Account for sticky headers or other offsets

			// Determine the target element and button text based on visibility
			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable; // Our target is the table itself
			} else {
				$button.text('View Table');
				$targetElement = card; // Our target is the card containing the chart
			}
            
            // This is a robust way to calculate the required scroll position.
            var currentScrollTop = $scrollContainer.scrollTop();
            var targetTop = $targetElement[0].getBoundingClientRect().top;
            var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;
            
            var scrollOffset = targetTop - containerTop - headerOffset;
            var newScrollTop = currentScrollTop + scrollOffset;
			
			// Jump instantly to the calculated position.
			$scrollContainer.scrollTop(newScrollTop);
			
		}, 10); // Using a 10ms timeout should be sufficient for reflow.

		// This is part of a hack for the modal height to make it work across browsers
		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});
	
	viewResultsProject = window.location.href;
	let currentProjectID = '';
	
	// Check if there's a hash in the URL
	if (viewResultsProject.includes('#')) {
		currentProjectID = viewResultsProject.split('#')[1];
	}
	
	// Extract the project ID from the URL path if it's not available from the hash
	if (!currentProjectID) {
		const projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1];  // Extract the part after '/projects/'
		}
	}
	
	$('.view-results').on('click', function() {
		$('.modal-body .loader').show();
		let projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			// Extract the slug portion, removing any trailing hashtags or other parts
			currentProjectID = projectPath[1].split(/[?#]/)[0]; // Split by '?' or '#' and take the first part
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		}
	});
	
	// Event listener for detecting when the #projectCompleteModal is shown
	$(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
		if (currentProjectID) {
			console.log('Project Complete Modal detected with Project ID:', currentProjectID);
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		} else {
			console.error('Project ID not found for #projectCompleteModal');
		}
	});
	
});